<script setup lang="ts">
/**
 * # Locale Link
 *
 * Wraps the `<NuxtLink>` component, optionally (by default) formatting links with the current locale prefix.
 *
 * `<LocaleLink>` is a drop-in replacement for Nuxt's `<NuxtLink>`, Vue Router's `<RouterLink>`, and HTML's `<a>` tag.
 *
 * @example
 * // If the current country requires a prefix (/com, /fr, ...), links to {domain}/{prefix}/products
 */

const props = withDefaults(
    defineProps<{
        to: string | RouteObject;
        format?: boolean;
        target?: '_blank' | '_self';
    }>(),
    {
        format: true,
        target: '_self',
    },
);

defineEmits<{
    click: [];
}>();

const { url } = useCountrySwitch();
const countrySpecificUrl = url(props.to);

const getLink = computed(() => {
    if (props.format) {
        return countrySpecificUrl;
    }

    return props.to;
});
</script>

<template>
    <NuxtLink
        v-bind="$attrs"
        :to="getLink"
        :target="target"
        @click="$emit('click')"
    >
        <slot />
    </NuxtLink>
</template>
